/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ProgramID } from "./ProgramID";
import type { ProgramStatus } from "./ProgramStatus";
import type { ProgramStatusChangeModel } from "./ProgramStatusChangeModel";
import type { UserProgramResponseDetails } from "./UserProgramResponseDetails";

export interface UserProgramResponse {
  user_id: string;
  program: ProgramID;
  status: ProgramStatus;
  status_history: ProgramStatusChangeModel[];
  progress_protocol: string | null;
  details: UserProgramResponseDetails;
}
